module.exports = __webpack_public_path__ + "media/images/players/NA_KEVIN-1fa71e8976a4cfe1c3ebd9f4bdfd9622.png";